import closePaneAndRevealAssets from './_closePaneAndRevealAssets';

export default {
    verb: 'didCreate',
    namespace: 'transaction',
    relation: 'itemsByModel',
    description:
        'collapse the "Create With Auto Serialization" detail pane and reveal the generated assets on save-success',
    logic: closePaneAndRevealAssets
};

// The create form for Serialized-Each model+quantity renders in a detail pane on the Assets
// grid: an item:item DetailPane (showForAction: 'newAutoSerial') hosting a self-managing
// SingleRecordForm on the virtual transaction:itemsByModel relation. On save-success the
// server bridge (didCreate_transaction_itemsByModel) returns the optimistic record as
// meta.deleted and the generated item:item assets arrive via import socket notifications.
// closePaneAndRevealAssets clears the host item:item ActiveRecord to collapse the pane, then
// resets the #332 display gate on item:item so the new assets appear without a manual sync
// (see _closePaneAndRevealAssets for the why).
